import React from 'react';
import { useSelector } from 'react-redux';
import { Tooltip, TooltipProps } from 'react-tippy';
import 'react-tippy/dist/tippy.css';

const TippyTooltip = Tooltip as React.ComponentType<
  TooltipProps & { children: React.ReactNode }
>;

import { Plan, PLAN_HIERARCHY } from 'modules/subscription';
import { UserSelectors } from 'modules/user';
import sailsImage from 'modules/ui/assets/images/Sails.png';

import {
  Container,
  SailsImage,
  TooltipBody,
  UpgradeLink,
} from './styledComponents';

type Props = {
  minimumPlan?: Plan;
  placement?: 'top' | 'bottom' | 'left' | 'right';
  children: React.ReactNode;
};

const Paywall: React.FC<Props> = ({
  minimumPlan = Plan.Free,
  placement = 'top',
  children,
}) => {
  const userPlanTier = useSelector(UserSelectors.userPlanTier);
  const pricingEnabled = process.env.REACT_APP_STRIPE_ENABLED === 'true';
  const isLocked =
    pricingEnabled &&
    PLAN_HIERARCHY[userPlanTier] < PLAN_HIERARCHY[minimumPlan];

  const tooltipContent = (
    <TooltipBody>
      <SailsImage src={sailsImage} alt="Sails" />
      Requires {minimumPlan} plan.{' '}
      <UpgradeLink href="/upgrade">Upgrade</UpgradeLink>
    </TooltipBody>
  );

  if (!isLocked) {
    return <>{children}</>;
  }

  return (
    <TippyTooltip
      html={tooltipContent}
      position={placement}
      trigger="mouseenter"
      interactive
      theme="transparent"
      animateFill={false}
      disabled={!isLocked}
    >
      <Container isLocked={isLocked}>{children}</Container>
    </TippyTooltip>
  );
};

export default React.memo(Paywall);
